import React from "react";

export const Footer = ({ onOpenLegal, onOpenCookieSettings }) => (
  <footer className="footer">
    <div className="container">
      <div className="footer__grid">
        <div>
          <div className="footer__brand">Casa Carmela</div>
          <p style={{ margin: 0, maxWidth: 320 }}>
            A family home in Liparlati, Positano. Three bedrooms, a terrace over the sea and hosts
            who know every corner of the Amalfi Coast.
          </p>
        </div>

        <div>
          <h4>Explore</h4>
          <ul>
            <li>
              <a href="#gallery">Gallery</a>
            </li>
            <li>
              <a href="#location">Location</a>
            </li>
            <li>
              <a href="#services">Amenities</a>
            </li>
            <li>
              <a href="#reviews">Reviews</a>
            </li>
          </ul>
        </div>

        <div>
          <h4>Stay</h4>
          <ul>
            <li>
              <a href="#booking">Book your stay</a>
            </li>
            <li>
              <a href="#contact">Contact us</a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/casacarmelapositano/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {new Date().getFullYear()} Casa Carmela Positano · CIN 15065100LOB0606</span>
        <div className="footer__legal">
          <button type="button" onClick={() => onOpenLegal("privacy")}>
            Privacy
          </button>
          <button type="button" onClick={() => onOpenLegal("cookies")}>
            Cookies
          </button>
          <button type="button" onClick={() => onOpenLegal("imprint")}>
            Legal notice
          </button>
          <button type="button" onClick={onOpenCookieSettings}>
            Cookie settings
          </button>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
